import request from '@/utils/request'

//  获得消息分页
 export function getStationMessagePage(query) {
    return request({
      url: '/system/msg/page',
      method: 'get',
      params: query
    })
  }

  export function updateReadStatus(data) {
    return request({
      url: '/system/msg/update_read_status',
      method: 'put',
      data:data
    })
  }
  export function updateWarn(data) {
    return request({
      url: '/system/msg/update_warn',
      method: 'put',
      data:data
    })
  }
